<template>
  <component :is="layout">
    <router-view />
  </component>
  <mobile-app-notice v-if="!esAdmin" />
</template>

<script>
import { isAuthenticated } from '@/api/auth'
import store from '@/store'
import MobileAppNotice from '@/components/Banners/MobileAppNotice.vue'

export default {
  name: 'App',
  components: { MobileAppNotice },
  computed: {
    esAdmin() {
      return (this.$route.meta.layout || '').startsWith('admin')
    },
    layout() {
      return (this.$route.meta.layout || 'dashboard') + '-layout'
    }
  },
  methods: {
    async logout() {
      this.$store.dispatch('afterSuccessLogin', null)
      this.$storage.removeStorageSync('loggedUser')
      this.$storage.removeStorageSync('showModal')
      this.$router.go()
    }
  },
  async created() {
    const user = store.getters.getUser || null

    if (user !== null) {
      try {
        const res = await isAuthenticated()

        if (res?.status >= 400) {
          await this.logout()
        }
      } catch (e) {
        await this.logout()
      }
    }
  }
}
</script>
